export default "/images/vendor/@coreui/icons/svg/flag/cif-mc.svg?c4b1dd0b5b403e02585cfe5c40761a18";